import { SettingsOutlined } from '@material-ui/icons';
import { GetRoutesConfig, RoutesMaps } from '../common/routes-map-model';
import { getMenuLabel } from '../../global/auth/use-menu-labels/use-menu-labels';

const route = 'admin';

export const getAdminRoutesMap = ({ userIdentityService, org }: GetRoutesConfig): RoutesMaps => {
  const menuLabels = org?.menuLabels;

  return {
    route,
    heading: 'Admin',
    Icon: SettingsOutlined,
    isAuthorized: userIdentityService.isVmAdmin,
    items: [
      {
        ...getMenuLabel('adminTaskManagement', menuLabels),
        route: 'tasks',
        isAuthorized: true,
      },
      {
        ...getMenuLabel('adminProgramManagement', menuLabels),
        route: 'program-management',
        isAuthorized: true,
      },
      {
        ...getMenuLabel('adminConsole', menuLabels),
        route: 'admin-console',
        isAuthorized: true,
      },
    ],
  };
};
